videoroomClient.directive('videoroomStats', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'videoroom_client/templates/' + helperService.getRedesignPathPrefix() + 'videoroomStats.html'
            )
        };
    }
]);
